/**
 * Empty State Component
 * Displayed when there are no records to show
 */
import React from 'react'
import styled from '@emotion/styled'
import { LangKey } from '../types'

interface EmptyStateProps {
  langKey: LangKey
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 20vh;
  color: #999;
  font-size: 1.2rem;
`

const EmptyState: React.FC<EmptyStateProps> = ({ langKey }) => {
  const message = langKey === 'zh-hant' ? '暫無記錄' : 'No records found'
  return <Wrapper>{message}</Wrapper>
}

export default EmptyState
